export default {
    AccountManagement: {
        staffLeave: {
            importLeave: 'Import Leave',
            viewLeave: 'View Leave Records',
            records: 'Leave Records',
            refresh: 'Refresh',
            empty: 'No leave records',
            loadFailed: 'Unable to load leave records. Click Refresh to try again.',
            serialNumber: 'Serial Number',
            createPerson: 'Created By',
            createPersonDept: 'Creator Department',
            type: 'Leave Type',
            startTime: 'Start Time',
            endTime: 'End Time',
            leaveHours: 'Leave Hours',
            noPayLeave: 'Unpaid Leave',
            duration: 'Duration',
            approveResult: 'Approval Result',
            approveStatus: 'Approval Status',
            leaveReason: 'Leave Reason',
            createTime: 'Created At',
        },
        staff: {
            name: 'Name',
            legalName: 'Legal Name',
            preferredName: 'Preferred Name',
            type: 'Type',
            department: 'Department',
            role: 'Role',
            hourlyRateWithLeave: 'Hourly Rate (With Leave)',
            regularHourlyRate: 'Regular Hourly Rate',
            decryptRates: 'Decrypt',
            privateKey: 'Private Key',
            privateKeyPlaceholder: 'Enter or upload the private key',
            uploadPrivateKey: 'Upload Private Key',
            privateKeyRequired: 'Please enter or upload the private key',
            decryptSuccess: 'Decrypted successfully',
            decryptFailed: 'Decryption failed. Please check the private key or ciphertext.',
            encryptFailed: 'Encryption failed. Please try again.',
            Full: 'Full-Time',
            Casual: 'Casual',
            Hire: 'Long-Term Labour Hire',
            Inbound: 'Inbound',
            Outbound: 'Outbound',
        },
        dept: {
            Management: 'Dept Management',
            department: 'Department',
            supervisor: 'Supervisor',
        },
        work: {
            review: 'Review',
            reviewTitle: 'Timesheet Review',
            reviewAll: 'All available departments',
            reviewRefresh: 'Refresh',
            reviewGap: 'Internal gap',
            reviewGapCount: '{count} gap(s) between recorded shifts, marked in amber. Time before the first shift and after the last shift is not flagged.',
            reviewFullDay: '00:00–24:00 · 30-minute intervals · Scroll horizontally to view the full day',
            reviewLocate: 'Go to first shift',
            reviewRequestError: 'Unable to load timesheet data. Refresh to retry.',
            reviewOvertime: 'Overtime applications',
            reviewNote: '30-minute grid; colours identify the department of each timesheet record. Filtering keeps all records for matching people. Red marks overlaps; amber marks internal gaps. Actual and overtime applications are reviewed separately.',
            reviewInvalid: '{count} record(s) have missing or invalid time ranges and cannot be displayed.',
            reviewConflict: '{count} overlapping record pair(s). Check the red-outlined bars and details below.',
            reviewOverlap: 'Time overlap',
            reviewPeople: '{count} people',
            reviewEmpty: 'No recorded working hours for this date and department.',
            reviewLoadError: 'Incomplete data. Unable to load: {departments}. Refresh to retry; overlap checking is incomplete.',
            reviewNoDepartments: 'No available departments. Please wait for the department list to load and refresh.',
            weekDay: 'Date',
            recommended: 'Recommended',
            plan: 'Plan',
            actual: 'Actual',
            over: 'Overtime',
            fill: 'Fill Planned Staff',
            staffSelect: 'Select Staff',
            labour: 'Labour Hire',
            num: 'Number',
            name: 'Name',
            role: 'Role',
            ReasonTitle: 'Enter Reason For Exceeding',
            enterReason: 'Reason required for exceeding recommended usage',
            fillActual: 'Fill Actual Staff',
            hour: 'Working Hours',
            Overtime: 'Overtime Application',
            info: 'Staff Information',
            Reason: 'Reason',
            Headcount: 'Headcount Status',
            Overtime: 'Overtime Status',
            targetGroup: 'Department',
            percentage: 'PERCENTAGE (%)',
            action: 'ACTION',
            addGroup: 'Add Group',
            close: 'Close',
            allocate: 'Allocate',
            count: 'Count',
            exportTimesheetReport: 'Export Timesheet Report',
            employeeType: 'Employee Type',
            fullTime: 'Full-time',
            casual: 'Casual',
            fullTimeOnly: '(Full-time employees only)',
            casualOnly: '(Casual employees only)',
            labourHireSection: 'Labour hire',
            labourHireOnly: '(Labour hire employees only)',
            fullTimeBiWeekly: 'Full-time (bi-weekly)',
            casualWeekly: 'Casual (weekly)',
            labourHire: 'Labour Hire',
            period: 'Period',
            pleaseSelect: 'Please Select',
            workDetailsDuplicateDept: '{module} row {row} Department has duplicate values',
            workDetailsPercentageNotEqual100: '{module} row {row} PERCENTAGE (%) is not equal to 100',
            workDetailsDataError: '{module} row {row} data error',
        },
        common: {
            account: 'Account',
            name: 'Name',
            belongto: 'Belong To',
            tenantName: 'Department Name',
            status: 'Status',
            Whether: 'Lock',
            Expired: 'Whether Expired',
            customer: 'Customer',
            cusName: 'Customer Ownership',
            from: 'Valid From',
            until: 'Valid Until',
            New: 'Add Account',
            NewCustom: 'Add Customer',
            edit: 'Edit',
            Info: 'Edit Billing Info',
            operate: 'Operate',
            structure: 'Associate Organizational Structure',
            Change: 'Change Password',
            lock: 'Lock',
            deblocking: 'UnLock',
            freeze: 'Freeze',
            unfreeze: 'Unfreeze',
            isfreeze: 'Freeze Status',
            isLeave: 'Exit Status',
            Leave: 'Mark as Exited',
            Back: 'Cancel Exited',
            termOfProtection: 'Grace Period',
            password: 'Password',
            Confirm: 'Confirm Password',
            ps: 'Please enter a password',
            ps1: 'Please enter a password of 6 to 20 characters',
            ps2: 'Please enter the password again',
            ps3: 'The two entered passwords do not match',
            ps4: 'You are',
            ps5: 'Are you sure you want to continue?',
            ps6: 'Operation Successful',
            ps7: 'Related statuses are disabled; the client is marked as exited.',
        },
        customer: {
            account: 'Customer code',
            name: 'Customer Name',
            status: 'Customer status',
            companyName: 'Company Name',
            activationTime: 'Date Activated',
            deactivationTime: 'Date Deactivated'
        },
        table: {
            phone: 'Mobile',
            email: 'Email',
            creator: 'Created By',
            createTime: 'Date Created',
            disableTip: 'Disabled due to account closure',
            freezeTip: 'Frozen due to account arrears',
            lockTip: 'Locked due to too many incorrect password attempts'
        },
        backup:{
            Contract: 'Contract',
            Rate: 'Rate Card',
            Terms: 'Terms and Conditions',
            Credit: 'Credit Application',
            Inbound: 'Inbound Checklist',
            Internal: 'Internal Handover Form',
            IT: 'IT Checklist',
            Others: 'Others',
        },
        dashboard:{
            Onboarding: 'Onboarding Progress Overview',
            Total: 'Total Onboarding Customer',
            Pending: 'Pending Approvals',
            Initial: 'Initial Operation',
            SKU: 'SKU',
            Store: 'Store',
            PO: 'PO',
            Order: 'Order',
            Tracker: 'Customer Operational Milestone Tracker',
            Customer: 'Customer',
            SKUi: 'SKU',
            SKUFirst: 'First SKU Creation',
            SKUCurrent: 'Current SKU Qty',
            SKUEstimated: 'Estimated SKU Qty',
            Complete: 'Complete',
            Storei: 'Store',
            StoreFirst: 'First Store Creation',
            StoreAPI: 'API Test',
            POi: 'PO',
            POFirst: 'First PO Creation',
            POArrived: 'First PO Arrived',
            POReceived: 'First PO Received',
            Orderi: 'Order',
            OrderFirst: 'First Order Pulled',
            OrderDispatched: 'First Order Dispatched',
        },
    }
};
